import { types } from "./../types/typesAuth";
const initialState = {
  activeUsuario: null,
  usuarios: [],
  modulos: [],
  perfiles: [],
  rutasModulo: [],
  activeModulo: null,
  activePerfil: null,
  activeRuta: null,
  checking: false,
  loading: false,
  visibleFormUsuario: false,
  visibleFormModulo: false,
};

export const usuarioReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.authUsuariosLoaded:
      return { ...state, usuarios: action.payload };
    case types.authUsuarioAdded:
      return {
        ...state,
        usuarios: [action.payload, ...state.usuarios],
      };
    case types.authUsuarioSetActive:
      return {
        ...state,
        activeUsuario: action.payload,
      };
    case types.authUsuarioClearActive:
      return {
        ...state,
        activeUsuario: null,
      };
    case types.authUsuarioUpdated:
      return {
        ...state,
        usuarios: state.usuarios.map((e) =>
          e.id === action.payload.id ? action.payload : e
        ),
      };
    case types.authUsuarioDeleted:
      return {
        ...state,
        usuarios: state.usuarios.filter((e) => e.id !== action.payload.id),
        activeUsuario: null,
      };
    case types.authUsuarioShowForm:
      return {
        ...state,
        visibleFormUsuario: action.payload,
      };
    case types.authStatusLoading:
      return {
        ...state,
        loading: action.payload,
      };
    case types.authModulosLoaded:
      return { ...state, modulos: action.payload };
    case types.authModuloAdded:
      return {
        ...state,
        modulos: [action.payload, ...state.modulos],
      };
    case types.authModuloSetActive:
      return {
        ...state,
        activeModulo: action.payload,
      };
    case types.authModuloClearActive:
      return {
        ...state,
        activeModulo: null,
      };
    case types.authRutaSetActive:
      return {
        ...state,
        activeRuta: action.payload,
      };
    case types.authRutaClearActive:
      return {
        ...state,
        activeRuta: null,
      };
    case types.authModuloUpdated:
      return {
        ...state,
        modulos: state.modulos.map((e) =>
          e.id === action.payload.id ? action.payload : e
        ),
      };
    case types.authModuloDeleted:
      return {
        ...state,
        modulos: state.modulos.filter((e) => e.id !== action.payload.id),
        activeModulo: null,
      };
    case types.authRutasModuloSetActive:
      return {
        ...state,
        rutasModulo: action.payload,
      };
    case types.authRutasModuloClearActive:
      return {
        ...state,
        rutasModulo: null,
      };
    case types.authRutaAdded:
      return {
        ...state,
        rutasModulo: [...state.rutasModulo, action.payload],
      };
    case types.authRutaUpdated:
      return {
        ...state,
        rutasModulo: state.rutasModulo.map((e) =>
          e.id === action.payload.id ? action.payload : e
        ),
      };
    case types.authRutaDeleted:
      return {
        ...state,
        rutasModulo: state.rutasModulo.filter(
          (e) => e.id !== action.payload.id
        ),
        activeRuta: null,
      };
    case types.authPerfilesLoaded:
      return { ...state, perfiles: action.payload };
    case types.authPerfilAdded:
      return {
        ...state,
        perfiles: [action.payload, ...state.perfiles],
      };
    case types.authPerfilUpdated:
      return {
        ...state,
        perfiles: state.perfiles.map((e) =>
          e.id === action.payload.id ? action.payload : e
        ),
      };
    case types.authPerfilDeleted:
      return {
        ...state,
        perfiles: state.perfiles.filter((e) => e.id !== action.payload.id),
        activePerfil: null,
      };
    case types.authPerfilSetActive:
      return {
        ...state,
        activePerfil: action.payload,
      };
    case types.authPerfilClearActive:
      return {
        ...state,
        activePerfil: null,
      };
    default:
      return state;
  }
};
